import { render, staticRenderFns } from "./ResponsibleDetailsIcon.vue?vue&type=template&id=5601f861&"
import script from "./ResponsibleDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./ResponsibleDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports